import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentationSidebar from './component/DocumentationSidebar';
import { useDocImage } from './hooks/useDocImage';


export default function Analytics() {
    const { t } = useTranslation();
    
    // Load language-specific images
    const image001 = useDocImage('analytics-img', 'image001.png');
    const image002 = useDocImage('analytics-img', 'image002.png');
    const image005 = useDocImage('analytics-img', 'image005.png');
    const image006 = useDocImage('analytics-img', 'image006.jpg');
    const image007 = useDocImage('analytics-img', 'image007.png');
    const image008 = useDocImage('analytics-img', 'image008.png');
    const image009 = useDocImage('analytics-img', 'image009.png');
    const image010 = useDocImage('analytics-img', 'image010.png');
    const image011 = useDocImage('analytics-img', 'image011.png');
    const image012 = useDocImage('analytics-img', 'image012.png');
    const image013 = useDocImage('analytics-img', 'image013.png');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>{t('documentation.analytics.title')}</h1>
                            <p className='header-para'>
                                {t('documentation.analytics.intro')}
                            </p>
                          

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.analytics.accessingPage.title')}
                                </div>
                                <div className="card-body">
                                    <ul>
                                        <li>{t('documentation.analytics.accessingPage.navigate')}</li>
                                        <img src={image001} alt={t('documentation.analytics.accessingPage.imageAlt')} className='img-fluid pt-10 pb-10' />
                                     </ul>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.analytics.surveyDataAnalysis.title')}
                                </div>
                                <div className="card-body">
                                    
                                    <p>{t('documentation.analytics.surveyDataAnalysis.viewDataIntro')}</p>
                                    <ul>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.steps.selectSurvey')}<br />
                                            <img src={image002} alt="leads name" className='pb-10 pt-10' />
                                        </li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.steps.chooseDateRange')}<br />
                                            <img src={image006} alt="Date range" className='pt-10 pb-10' />
                                        </li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.steps.graphsDisplay')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.steps.topLeads')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.steps.viewAll')}</li>
                                    </ul>
                                    <p>{t('documentation.analytics.surveyDataAnalysis.note')}</p>
                                    <p>{t('documentation.analytics.surveyDataAnalysis.graphTypes')}</p>
                                    <ul>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.graphTypesList.completion')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.graphTypesList.maturity')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.graphTypesList.questionWise')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.graphTypesList.exit')}</li>
                                        <li>{t('documentation.analytics.surveyDataAnalysis.graphTypesList.topLeads')}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.analytics.dataAnalysisGraphs.title')}
                                </div>
                                <div className="card-body">
                                   
                                    <p><b>{t('documentation.analytics.dataAnalysisGraphs.completionAnalysis.title')}</b></p>
                                    <img src={image007} alt="Completion-Analysis" className='pb-10' />
                                    <ul>
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.completionAnalysis.desc1')}</li>
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.completionAnalysis.desc2')}</li>
                                    </ul>

                                    <p><b>{t('documentation.analytics.dataAnalysisGraphs.maturityAnalysis.title')}</b></p>
                                    <ul>
                                    <img src={image008} alt="Maturity-Analysis" className='pb-10' />
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.maturityAnalysis.desc1')}</li>
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.maturityAnalysis.desc2')}</li>
                                    </ul>

                                    <p><b>{t('documentation.analytics.dataAnalysisGraphs.questionWiseAnalysis.title')}</b></p>
                                    <ul>
                                    <img src={image009} alt="Question-Wise-Analysis" className='img-fluid pb-10' />
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.questionWiseAnalysis.desc1')}</li>
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.questionWiseAnalysis.desc2')}</li>
                                    </ul>

                                    <p><b>{t('documentation.analytics.dataAnalysisGraphs.exitAnalysis.title')}</b></p>
                                    <ul>
                                    <img src={image010} alt="Exit-Analysis" className='img-fluid pb-10' />
                                        <li>{t('documentation.analytics.dataAnalysisGraphs.exitAnalysis.desc')}</li>
                                    </ul>

                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.analytics.dataLeadsTable.title')}
                                </div>
                                <div className="card-body">
                                    
                                    <p><b>{t('documentation.analytics.dataLeadsTable.topLeadsTitle')}</b></p>
                                    
                                    <p>{t('documentation.analytics.dataLeadsTable.topLeadsDesc')}</p>
                                    <img src={image011} alt="Data Leads Table" className='img-fluid pt-10 pb-30' />
                                    <p className='pt-10'><b>{t('documentation.analytics.dataLeadsTable.viewAllClick')}</b></p>
                                    <img src={image012} alt="All-Data-Leads-Table" className='img-fluid pt-10 pb-20' />
                                    <ul>
                                        <li><b>Date</b> — {t('documentation.analytics.dataLeadsTable.fields.date')}</li>
                                        <li><b>Report Link</b> — {t('documentation.analytics.dataLeadsTable.fields.reportLink')}</li>
                                        <li><b>First Name</b> — {t('documentation.analytics.dataLeadsTable.fields.firstName')}</li>
                                        <li><b>Last Name</b> — {t('documentation.analytics.dataLeadsTable.fields.lastName')}</li>
                                        <li><b>Email Address</b> — {t('documentation.analytics.dataLeadsTable.fields.email')}</li>
                                        <li><b>Phone Number</b> — {t('documentation.analytics.dataLeadsTable.fields.phone')}</li>
                                        <li><b>Organization Name</b> — {t('documentation.analytics.dataLeadsTable.fields.organization')}</li>
                                        <li><b>Industry</b> — {t('documentation.analytics.dataLeadsTable.fields.industry')}</li>
                                        <li><b>No. of Responses</b> — {t('documentation.analytics.dataLeadsTable.fields.responses')}</li>
                                        <li><b>Maturity Level</b> — {t('documentation.analytics.dataLeadsTable.fields.maturityLevel')}</li>
                                        <li><b>Total Score</b> — {t('documentation.analytics.dataLeadsTable.fields.totalScore')}</li>
                                        <li><b>Completed</b> — {t('documentation.analytics.dataLeadsTable.fields.completed')}</li>
                                        <li><b>Unique ID</b> — {t('documentation.analytics.dataLeadsTable.fields.uniqueId')}</li>
                                        <li><b>UTM Source</b> — {t('documentation.analytics.dataLeadsTable.fields.utmSource')}</li>
                                        <li><b>UTM Medium</b> — {t('documentation.analytics.dataLeadsTable.fields.utmMedium')}</li>
                                        <li><b>UTM Campaign</b> — {t('documentation.analytics.dataLeadsTable.fields.utmCampaign')}</li>
                                        <li><b>T & C</b> — {t('documentation.analytics.dataLeadsTable.fields.termsConditions')}</li>
                                        <li><b>Action</b> — {t('documentation.analytics.dataLeadsTable.fields.action')}</li>
                                    </ul>

                                    <p><b>{t('documentation.analytics.dataLeadsTable.exportButton')}</b></p>
                                    <img src={image005} alt="Export-Button" className='pb-10' />
                                    <ul>
                                        <li>{t('documentation.analytics.dataLeadsTable.exportDesc')}</li>
                                    </ul>

                                    <p><b>{t('documentation.analytics.dataLeadsTable.deleteSelectedTitle')}</b></p>
                                    <img src={image013} alt="Delete-Selected-Leads" className='pb-10' />
                                    <ul>
                                        <li>{t('documentation.analytics.dataLeadsTable.deleteSelectedSteps.step1')}</li>
                                        <li>{t('documentation.analytics.dataLeadsTable.deleteSelectedSteps.step2')}</li>
                                        <li>{t('documentation.analytics.dataLeadsTable.deleteSelectedSteps.step3')}</li>
                                        <li>{t('documentation.analytics.dataLeadsTable.deleteSelectedSteps.step4')}</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
